/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The current order status.
 */
export enum OrderStatus {
    PRESIGNATURE_PENDING = 'presignaturePending',
    OPEN = 'open',
    FULFILLED = 'fulfilled',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
}
